import { jsx as _jsx } from "react/jsx-runtime";
import { renderLazyAskSourceSuggestion } from '#pplx/frontend/apps/ask/ask-input/ask-input-plus-menu/components/renderLazyAskSourceSuggestion.js';
import { useAskSourceSuggestionAnalytics } from '#pplx/frontend/apps/ask/ask-input/source-suggestions/analytics/useAskSourceSuggestionAnalytics.js';
import { SourceSuggestions as ComposerSourceSuggestions } from '#pplx/frontend/composer-sdk-plugins/source-suggestion/SourceSuggestions.js';
import { memo } from 'react';
export const SourceSuggestions = memo(function SourceSuggestions({ query, ...props }) {
    const analytics = useAskSourceSuggestionAnalytics(query);
    return (_jsx(ComposerSourceSuggestions, { ...props, ...analytics, renderSuggestion: renderLazyAskSourceSuggestion }));
});
//# sourceMappingURL=SourceSuggestions.js.map